import React, { Component, createRef } from 'react'
import { Icon, Loader } from 'semantic-ui-react'

export default class Video extends Component {
    constructor(props){
        super(props);
        this.state = {
            playing: true,
            loading: true
        }
        this.videoRef = createRef()
    }

    togglePlay(video) {
        if (video.currentTime > 0 && !video.paused && video.readyState > 2 && this.state.playing === true) {
            this.setState({playing: false})
            video.pause()
        } else {
            this.setState({playing: true})
            video.play()
        }
    }

    render() {
        return <div className={this.state.playing ? 'videoWrapper' : 'videoWrapper paused'} >
            <Icon
                size='large'
                className='videoPlayIcon'
                name='play' />
            <Loader active={this.state.loading} />
            <video
                ref={this.videoRef}
                onClick={() => {
                    this.togglePlay(this.videoRef.current)
                }}
                onLoadedData={() => {
                    this.setState({
                        loading: false,
                        playing: this.videoRef.current.playing
                    })
                }}
                onPlay={() => {
                    this.setState({
                        playing: true
                    })
                }}
                {...this.props}
                autoPlay
                muted
                loop
            />
        </div>
    }
}
